import React, { useState } from 'react';
import { db } from '../firebase';
import { collection, addDoc } from 'firebase/firestore';

function AddRecord({ userId, onClose, onSuccess, guestMode }) {
  const today = new Date().toISOString().split('T')[0];
  const [date, setDate] = useState(today);
  const [height, setHeight] = useState('');
  const [weight, setWeight] = useState('');
  const [memo, setMemo] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!date || !height || !weight) {
      alert('모든 정보를 입력해주세요.');
      return;
    }

    if (parseFloat(height) <= 0 || parseFloat(weight) <= 0) {
      alert('올바른 수치를 입력해주세요.');
      return;
    }

    setLoading(true);
    try {
      if (guestMode) {
        // 비회원 모드: localStorage에 저장
        const newRecord = {
          id: Date.now().toString(),
          date,
          height: parseFloat(height),
          weight: parseFloat(weight),
          memo: memo.trim() || '',
          createdAt: new Date().toISOString()
        };

        // 기존 기록 불러오기
        const existingRecords = JSON.parse(localStorage.getItem('guestRecords') || '[]');
        existingRecords.push(newRecord);
        localStorage.setItem('guestRecords', JSON.stringify(existingRecords));

        alert('✅ 기록이 저장되었습니다!\n\n💡 비회원 모드에서는 브라우저에 임시 저장됩니다.\n로그인하시면 영구적으로 안전하게 보관됩니다.');
        onSuccess();
        onClose();
        setLoading(false);
      } else {
        await addDoc(collection(db, 'users', userId, 'records'), {
          date,
          height: parseFloat(height),
          weight: parseFloat(weight),
          memo: memo.trim() || '',
          createdAt: new Date().toISOString()
        });

        alert('기록이 저장되었습니다!');
        onSuccess();
        onClose();
        setLoading(false);
      }
    } catch (error) {
      console.error('기록 저장 실패:', error);
      alert('기록 저장에 실패했습니다. 다시 시도해주세요.');
      setLoading(false);
    }
  };

  return (
    <div className="fade-in" style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 1000,
      padding: '20px'
    }}>
      <div className="slide-up" style={{
        backgroundColor: 'white',
        borderRadius: '24px',
        padding: '40px',
        maxWidth: '400px',
        width: '100%',
        position: 'relative'
      }}>
        <button
          onClick={onClose}
          style={{
            position: 'absolute',
            top: '16px',
            right: '16px',
            background: 'none',
            border: 'none',
            fontSize: '24px',
            cursor: 'pointer',
            color: '#8B7355'
          }}
        >
          ×
        </button>

        <div style={{
          textAlign: 'center',
          marginBottom: '32px'
        }}>
          <div style={{ fontSize: '48px', marginBottom: '16px' }}>📝</div>
          <h2 style={{
            color: '#E8A87C',
            fontSize: '24px',
            marginBottom: '8px'
          }}>
            성장 기록 추가
          </h2>
          <p style={{
            color: '#8B7355',
            fontSize: '14px'
          }}>
            아기의 키와 몸무게를 기록하세요
          </p>
        </div>

        {guestMode && (
          <div style={{
            backgroundColor: '#FFF3CD',
            border: '2px solid #FFD700',
            borderRadius: '12px',
            padding: '12px 16px',
            marginBottom: '24px',
            fontSize: '13px',
            color: '#856404',
            lineHeight: '1.5',
            textAlign: 'center'
          }}>
            ⚠️ <strong>비회원 체험 모드</strong><br />
            폼을 사용해볼 수 있지만 기록은 저장되지 않습니다.
          </div>
        )}

        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: '20px' }}>
            <label style={{
              display: 'block',
              color: '#8B7355',
              fontSize: '14px',
              fontWeight: 'bold',
              marginBottom: '8px'
            }}>
              측정 날짜
            </label>
            <input
              type="date"
              value={date}
              onChange={(e) => setDate(e.target.value)}
              max={today}
              style={{
                width: '100%',
                padding: '12px',
                border: '2px solid #F5E6D3',
                borderRadius: '12px',
                fontSize: '16px',
                outline: 'none',
                transition: 'border-color 0.2s',
                boxSizing: 'border-box'
              }}
              onFocus={(e) => e.target.style.borderColor = '#E8A87C'}
              onBlur={(e) => e.target.style.borderColor = '#F5E6D3'}
            />
          </div>

          <div style={{ marginBottom: '20px' }}>
            <label style={{
              display: 'block',
              color: '#8B7355',
              fontSize: '14px',
              fontWeight: 'bold',
              marginBottom: '8px'
            }}>
              키 (cm)
            </label>
            <input
              type="number"
              step="0.1"
              value={height}
              onChange={(e) => setHeight(e.target.value)}
              placeholder="예) 75.5"
              style={{
                width: '100%',
                padding: '12px',
                border: '2px solid #F5E6D3',
                borderRadius: '12px',
                fontSize: '16px',
                outline: 'none',
                transition: 'border-color 0.2s',
                boxSizing: 'border-box'
              }}
              onFocus={(e) => e.target.style.borderColor = '#E8A87C'}
              onBlur={(e) => e.target.style.borderColor = '#F5E6D3'}
            />
          </div>

          <div style={{ marginBottom: '20px' }}>
            <label style={{
              display: 'block',
              color: '#8B7355',
              fontSize: '14px',
              fontWeight: 'bold',
              marginBottom: '8px'
            }}>
              몸무게 (kg)
            </label>
            <input
              type="number"
              step="0.1"
              value={weight}
              onChange={(e) => setWeight(e.target.value)}
              placeholder="예) 9.5"
              style={{
                width: '100%',
                padding: '12px',
                border: '2px solid #F5E6D3',
                borderRadius: '12px',
                fontSize: '16px',
                outline: 'none',
                transition: 'border-color 0.2s',
                boxSizing: 'border-box'
              }}
              onFocus={(e) => e.target.style.borderColor = '#E8A87C'}
              onBlur={(e) => e.target.style.borderColor = '#F5E6D3'}
            />
          </div>

          <div style={{ marginBottom: '32px' }}>
            <label style={{
              display: 'block',
              color: '#8B7355',
              fontSize: '14px',
              fontWeight: 'bold',
              marginBottom: '8px'
            }}>
              메모 <span style={{ fontSize: '12px', color: '#D4956B', fontWeight: 'normal' }}>(선택사항)</span>
            </label>
            <textarea
              value={memo}
              onChange={(e) => setMemo(e.target.value)}
              placeholder="예) 첫 이유식, 아팠음, 특이사항 등"
              maxLength={200}
              style={{
                width: '100%',
                padding: '12px',
                border: '2px solid #F5E6D3',
                borderRadius: '12px',
                fontSize: '16px',
                outline: 'none',
                transition: 'border-color 0.2s',
                boxSizing: 'border-box',
                minHeight: '80px',
                fontFamily: 'inherit',
                resize: 'vertical'
              }}
              onFocus={(e) => e.target.style.borderColor = '#E8A87C'}
              onBlur={(e) => e.target.style.borderColor = '#F5E6D3'}
            />
            <div style={{
              textAlign: 'right',
              fontSize: '11px',
              color: '#8B7355',
              marginTop: '4px'
            }}>
              {memo.length}/200
            </div>
          </div>

          <div style={{
            display: 'grid',
            gridTemplateColumns: '1fr 1fr',
            gap: '12px'
          }}>
            <button
              type="button"
              onClick={onClose}
              style={{
                padding: '16px',
                backgroundColor: 'white',
                border: '2px solid #F5E6D3',
                borderRadius: '12px',
                fontSize: '16px',
                fontWeight: 'bold',
                color: '#8B7355',
                cursor: 'pointer',
                transition: 'background-color 0.2s'
              }}
              onMouseOver={(e) => e.target.style.backgroundColor = '#FAF3E8'}
              onMouseOut={(e) => e.target.style.backgroundColor = 'white'}
            >
              취소
            </button>
            <button
              type="submit"
              disabled={loading}
              style={{
                padding: '16px',
                backgroundColor: loading ? '#D4956B' : '#E8A87C',
                color: 'white',
                border: 'none',
                borderRadius: '12px',
                fontSize: '16px',
                fontWeight: 'bold',
                cursor: loading ? 'not-allowed' : 'pointer',
                transition: 'background-color 0.2s'
              }}
              onMouseOver={(e) => {
                if (!loading) e.target.style.backgroundColor = '#D4956B';
              }}
              onMouseOut={(e) => {
                if (!loading) e.target.style.backgroundColor = '#E8A87C';
              }}
            >
              {loading ? '저장 중...' : '저장하기'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default AddRecord;
